// The building grid for the sheet page on screen, fetched only while it is switched on (helpers: api/glance/
// sheetGrid). Keyed by project, document and page, so a page flip asks again and a stale answer never lands on
// the next page.
import { useEffect, useState } from "react";
import { getSheetGrid } from "api/glance/sheetGrid";

// Stable answers for "off" / "no sheet" / "loading", so a canvas that redraws on
// a change of this value does not redraw on every render.
const OFF = Object.freeze({ lines: [], reason: null, loading: false });
const NO_SHEET = Object.freeze({ lines: [], reason: "not-registered", loading: false });
const LOADING = Object.freeze({ lines: [], reason: null, loading: true });

// A Document Control row carries its project as an id or populated ({ _id, title }).
const idOf = (v) => (v && typeof v === "object" ? v._id : v) || "";

export default function useSheetGrid(projectRef, docRef, page, on, fetchGrid = getSheetGrid) {
  const projectId = String(idOf(projectRef));
  const docId = String(idOf(docRef));
  const [state, setState] = useState({ key: "", lines: [], reason: null, loading: false });
  const key = projectId && docId ? `${projectId}|${docId}|${page || 1}` : "";
  useEffect(() => {
    if (!on || !key) return undefined;
    let alive = true;
    setState({ key, lines: [], reason: null, loading: true });
    fetchGrid(projectId, docId, page || 1).then((r) => {
      if (alive) setState({ key, lines: r.lines || [], reason: r.reason || null, loading: false });
    });
    return () => { alive = false; };
  }, [on, key]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!on) return OFF;
  if (!key) return NO_SHEET;
  return state.key === key && !state.loading ? state : LOADING;
}
